<div class="container">
  <div class="title-and-logo">
    <div class="logo-wrapper">
      <a [routerLink]="this.routingService.defaultGpPage" routerLinkActive="active">
        <img src="/assets/images/logo/logo-dashboard.svg"/>
      </a>
    </div>
    <h1 *ngIf="pageTitle">{{ pageTitle }}</h1>
  </div>

  <nav>
    <ng-container *ngIf="showNav">
      <a [routerLink]="this.routingService.gpFundsPage" routerLinkActive="active"
         (click)="forceReloadOnSamePage(this.routingService.gpFundsPage)" terraCheckPermissions
         [noPermissionAction]="NoPermissionAction.PopupOnClick" [sectionsAccess]="SectionsAccess.Funds">Funds</a>

      <a [routerLink]="this.routingService.gpAssetsPage" routerLinkActive="active"
         (click)="forceReloadOnSamePage(this.routingService.gpAssetsPage)" terraCheckPermissions
         [noPermissionAction]="NoPermissionAction.PopupOnClick" [sectionsAccess]="SectionsAccess.Assets">Assets</a>

      <a [routerLink]="this.routingService.insightsPage" routerLinkActive="active"
         (click)="forceReloadOnSamePage(this.routingService.insightsPage)" terraCheckPermissions
         [noPermissionAction]="NoPermissionAction.PopupOnClick" [sectionsAccess]="SectionsAccess.Insights">Insights</a>

      <a [routerLink]="this.routingService.contactsPage()" routerLinkActive="active"
         (click)="forceReloadOnSamePage(this.routingService.contactsPage())" terraCheckPermissions
         [noPermissionAction]="NoPermissionAction.PopupOnClick" [sectionsAccess]="SectionsAccess.Contacts">Contacts</a>

      <a [routerLink]="this.routingService.positionsPage()" routerLinkActive="active"
         (click)="forceReloadOnSamePage(this.routingService.positionsPage())" terraCheckPermissions
         [noPermissionAction]="NoPermissionAction.PopupOnClick" [sectionsAccess]="SectionsAccess.Positions">Positions</a>

      <a [routerLink]="this.routingService.bankAccountsPage()" routerLinkActive="active"
         (click)="forceReloadOnSamePage(this.routingService.bankAccountsPage())" terraCheckPermissions
         [noPermissionAction]="NoPermissionAction.PopupOnClick" [sectionsAccess]="SectionsAccess.BankAccounts">Bank Accounts</a>
    </ng-container>
  </nav>

  <terra-account-actions *ngIf="showAccountActions" />

</div>
